<div class="card">
  <div class="card-header pb-0">
    <div class="media-space-between">
      <h4>{{ "admin.locations.repository.title" | translate }}</h4>
      <div class="media-body">
        <form class="d-inline-flex" [formGroup]="formFilter">
          <app-date-range-picker
            [form]="formFilter | asFormGroup"
            inputFormControlName="date"
          ></app-date-range-picker>
          <div class="m-r-10">
            <app-search-field
              [form]="formFilter | asFormGroup"
              [filterOptions]="filterPayment"
              [placeholder]="'placeholder.searchByCompanyName' | translate"
              inputFormControlName="companyName"
              (emitSelectedOptions)="saveOptionFilter($event)"
            ></app-search-field>
          </div>
          <div>
            <app-refresh-button
              [state]="fetchingHistoryState"
              [date]="cachedAt"
              (buttonClick)="filterData(true)"
            ></app-refresh-button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="card-body">
    <div class="table-responsive data-table">
      <form>
        <table class="table table-border-vertical">
          <thead>
            <tr>
              <th
                [rowSpan]="rowSpan"
                sortable
                class="sortable"
                sortable="companyName"
              >
                {{ "admin.locations.repository.locations" | translate }}
              </th>
              <ng-container *ngFor="let column of columns">
                <th [rowSpan]="rowSpan">
                  {{ column.label | translate }}
                </th>
              </ng-container>
              <th [rowSpan]="rowSpan">
                {{ "buttons.actions" | translate }}
              </th>
            </tr>
          </thead>
          <tbody *ngIf="!loading">
            <ng-container
              *ngFor="let locationPartner of remunerationDetails; let i = index"
            >
              <ng-container
                *ngFor="
                  let advertisingCampaign of locationPartner.advertisingCampaigns
                "
              >
                <tr
                  [ngStyle]="
                    i % 2
                      ? { '--bs-table-accent-bg': '#ffffff' }
                      : { '--bs-table-accent-bg': '#f3f3f3' }
                  "
                >
                  <ng-template #none>
                    <td>
                      {{ "undefined" | translate }}
                    </td>
                  </ng-template>
                  <td
                    class="td-border-bottom-color"
                    *ngIf="
                      advertisingCampaign ===
                      locationPartner.advertisingCampaigns[0]
                    "
                    [attr.rowspan]="locationPartner.advertisingCampaigns.length"
                  >
                    {{ locationPartner.companyName }}
                  </td>

                  <td
                    class="td-border-bottom-color"
                    *ngIf="
                      advertisingCampaign ===
                      locationPartner.advertisingCampaigns[0]
                    "
                    [attr.rowspan]="locationPartner.advertisingCampaigns.length"
                  >
                    {{ locationPartner.pilotPhaseEndDate | localizedDate }}
                  </td>

                  <td
                    class="td-border-bottom-color"
                    *ngIf="
                      advertisingCampaign ===
                      locationPartner.advertisingCampaigns[0]
                    "
                    [attr.rowspan]="locationPartner.advertisingCampaigns.length"
                  >
                    {{ locationPartner.price }}
                  </td>

                  <td class="td-border-bottom-color">
                    {{ advertisingCampaign.title }}
                    <i
                      class="icofont icofont-check-circled color-success"
                      *ngIf="advertisingCampaign.isPaid; else notPaid"
                    ></i>
                    <ng-template #notPaid>
                      <i
                        class="icofont icofont-close-circled"
                        style="color: red"
                      ></i>
                    </ng-template>
                  </td>

                  <td class="td-border-bottom-color">
                    {{ advertisingCampaign.startDate | localizedDate }}
                  </td>

                  <td class="td-border-bottom-color">
                    {{ advertisingCampaign.endDate | localizedDate }}
                  </td>

                  <td class="td-border-bottom-color">
                    {{ advertisingCampaign.impressions }}
                  </td>

                  <td class="td-border-bottom-color">
                    {{ advertisingCampaign.revenueAmount.toFixed(3) }} TND
                    <app-info-tooltip-component
                      *ngIf="
                        showTooltip(advertisingCampaign.remunerationStatus)
                      "
                      [infoTooltip]="
                        getRevenueTooltip(
                          advertisingCampaign.paidImpressions,
                          advertisingCampaign.paidPeriodStart,
                          advertisingCampaign.paidPeriodEnd
                        )
                      "
                    ></app-info-tooltip-component>
                  </td>
                  <td
                    class="td-border-bottom-color"
                    *ngIf="
                      advertisingCampaign ===
                      locationPartner.advertisingCampaigns[0]
                    "
                    [attr.rowspan]="locationPartner.advertisingCampaigns.length"
                  >
                    <app-drop-zone-options
                      [options]="options"
                      (optionSelected)="
                        saveOption(
                          $event,
                          locationPartner,
                          locationPartner.advertisingCampaigns
                        )
                      "
                    ></app-drop-zone-options>
                  </td>
                </tr>
              </ng-container>
            </ng-container>
          </tbody>
        </table>
        <div *ngIf="forbidden" class="d-flex justify-content-center m-t-20">
          {{ "response.error.FORBIDDEN_RESPONSE" | translate }}
        </div>
        <div *ngIf="loading && !forbidden">
          <ng-container style="float: right" class="flex">
            <div class="loader-box">
              <div class="loader-34"></div>
            </div>
            <h6
              class="col align-self-center f-w-600"
              style="text-align: center"
            >
              {{ "fetching" | translate }}
            </h6>
          </ng-container>
        </div>
        <div
          *ngIf="count == 0 && !loading && !forbidden"
          class="d-flex justify-content-center m-t-20"
        >
          {{ "noData" | translate }}
        </div>
      </form>
    </div>
    <app-pager
      [count]="count"
      [pageSize]="pageSize"
      [pageNumber]="pageNumber"
      (emitChangePage)="changePage($event)"
      (emitChangePageSize)="itemsPerPageChange($event)"
    ></app-pager>
  </div>
</div>
